import { useEffect, useState } from 'react';

function SiteHeader() {
    const [hasScrolled, setHasScrolled] = useState(() => window.scrollY > 40);
    const [menuOpen, setMenuOpen] = useState(false);

    useEffect(() => {
        let frameId = null;
        let previousState = window.scrollY > 40;

        const updateHeader = () => {
            frameId = null;
            const nextState = window.scrollY > 40;
            if (nextState !== previousState) {
                previousState = nextState;
                setHasScrolled(nextState);
            }
        };

        const handleScroll = () => {
            if (frameId === null) {
                frameId = window.requestAnimationFrame(updateHeader);
            }
        };

        window.addEventListener('scroll', handleScroll, { passive: true });
        return () => {
            window.removeEventListener('scroll', handleScroll);
            if (frameId !== null) {
                window.cancelAnimationFrame(frameId);
            }
        };
    }, []);

    const closeMenu = () => setMenuOpen(false);

    return (
        <header className={`site-header${hasScrolled ? ' is-scrolled' : ''}`}>
            <a href="#top" aria-label="Aditya Patel, back to top" onClick={closeMenu}>Aditya Patel</a>
            <button
                className="menu-toggle"
                type="button"
                aria-expanded={menuOpen}
                aria-controls="primary-navigation"
                aria-label={menuOpen ? 'Close navigation' : 'Open navigation'}
                onClick={() => setMenuOpen((open) => !open)}
            >
                <span className={`menu-icon${menuOpen ? ' is-open' : ''}`} aria-hidden="true">
                    <span />
                    <span />
                    <span />
                </span>
            </button>
            <nav id="primary-navigation" className={menuOpen ? 'is-open' : ''} aria-label="Primary navigation">
                <a href="#about" onClick={closeMenu}>About</a>
                <a href="#experience" onClick={closeMenu}>Experience</a>
                <a href="#work" onClick={closeMenu}>Work</a>
                <a href="#contact" onClick={closeMenu}>Contact</a>
                <a href="/AdityaPatelResume.pdf" onClick={closeMenu}>Résumé</a>
            </nav>
        </header>
    );
}

export default SiteHeader;
